'use strict';
var parent = require('../../stable/object/from-entries');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/object/from-entries.js
// module id = 332
// module chunks = 0